export default [
  {
    description: 'Chat do Responsável com o Professor',
    path: '/ferramentas/chat_responsavel_professor',
    name: 'chat_responsavel_professor', //SAEWEB NEW
    component: () => import('@/views/ferramentas/chat_responsavel_professor/Index.vue'),
    meta: {
      isLegacy: false,
      permissions: [
      ],
    },
    goesToMenu: true,
  },
  {
    description: 'Chat do Responsável com o Professor',
    path: '/ferramentas/chat_responsavel_professor',
    name: 'chat2_responsavel_professor',
    component: () => import('@/views/ferramentas/chat_responsavel_professor/Index.vue'),
    meta: {
      isLegacy: true, //remover quando não for utilizar pelo SAEWEB antigo. Daí, vai aplicar o template por padrão
      permissions: [

      ],
    },
    goesToMenu: true,
  },
]

